import React from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { ContextProvider } from './store/context';
import App from './App';

const libraries = ['maps', 'drawing', 'geometry', 'places', 'marker'];

export default function Main() {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    libraries: libraries,
    // eslint-disable-next-line no-undef
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });
  if (isLoaded) {
    return (
      <ContextProvider>
        <App isLoaded={isLoaded} />
      </ContextProvider>
    );
  } else {
    return <>Loading...</>;
  }
}
